export default {"src":"/_next/static/media/link-orange.1cfa3305.svg","height":32,"width":32};